module.exports = __webpack_public_path__ + "static/media/joinedTournaments_1000.3b74f9c1.png";